export default __webpack_public_path__ + "79edfd5f1fc1a43425590fd033381705.jpeg";